import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./plugins/bugsnag";
import "./plugins/elastic-apm";

import VueAnalytics from "vue-analytics";
try {
  Vue.use(VueAnalytics, {
    id: "UA-134143816-2",
    router,
    autoTracking: {
      page: true,
      pageviewTemplate(route) {
        return {
          page: route.path,
          title: document.title,
          location: window.location.href
        };
      }
    }
  });
} catch (err) {
  console.error(err);
}
Vue.config.productionTip = false;
/**
 * @type {import('vue').VueConstructor}
 */
const options = {
  router,
  store,
  vuetify,
  render: h => h(App)
};
new Vue(options).$mount("#app");
